import { useDesignTokens } from "@boi/react-design-tokens";
import { ProgressBar as ProgressBarPrimitive } from "react-aria-components";
import styled, { css, keyframes } from "styled-components";

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const ProgressBar = styled(ProgressBarPrimitive)<{
  $color: string;
  $size: string;
}>`
  overflow: hidden;
  display: inline-block;
  position: relative;
  ${({ $size, $color }) => css`
    color: ${$color};
    width: ${$size};
    height: ${$size};
  `}
`;

export type CircleProps = {
  $borderWidth: string;
};

export const Circle = styled.div<CircleProps>`
  position: absolute;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  ${({ $borderWidth }) => {
    const {
      tokens: { spinner },
    } = useDesignTokens();

    return css`
      border: ${$borderWidth} solid currentColor;
      opacity: ${spinner.backgroundOpacity};
    `;
  }}
`;

export const Shard = styled.div<
  CircleProps & {
    $index: number;
  }
>`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 50%;
  animation: ${rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: currentColor transparent transparent transparent;
  ${({ $index, $borderWidth }) => {
    return css`
      border-width: ${$borderWidth};
      border-style: solid;
      animation-delay: ${0.15 * ($index + 1)}s;
    `;
  }}
`;
